import {
  Box,
  Card,
  CircularProgress,
  Container,
  Icon,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useMemo, useState } from "react";

import { isNil } from "lodash";
import {
  CloseFullscreenOutlined,
  OpenInFullOutlined,
} from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import Flx from "../layout/Flx";
import Htag from "../typography/Htag";
import Txt from "../typography/Txt";

const PrimaryContentCard = ({
  children,
  title,
  subTitle,
  subTitleContent,
  endContent,
  loading = false,
  expandedable = false,
  maxWidth,
  sx,
  cardSx,
  headerSx,
  containerSx,
  bodySx,
  titleSx,
}) => {
  const [expanded, setExpanded] = useState(false);
  const rootStyles = useMemo(() => {
    return {
      py: 4,
      ...sx,
      ...containerSx,
    };
  }, [sx, containerSx]);

  const cardContent = (
    <CardPaper sx={cardSx}>
      {/* <Flx column gap={2} sx={{ p: 2 }}> */}
      <Header
        title={title}
        subTitle={subTitle}
        subTitleContent={subTitleContent}
        expanded={expanded}
        titleSx={titleSx}
        expandedable={expandedable}
        endContent={endContent}
        onExpandClick={() => setExpanded(!expanded)}
        sx={headerSx}
      />

      {loading ? (
        <Flx center>
          <CircularProgress size={24} sx={{ my: 8 }} />
        </Flx>
      ) : (
        <Box sx={bodySx}>{children}</Box>
      )}
      {/* </Flx> */}
    </CardPaper>
  );

  if (maxWidth) {
    return (
      <Container maxWidth={expanded ? false : maxWidth} sx={rootStyles}>
        {cardContent}
      </Container>
    );
  }
  return cardContent;
};

export const CardPaper = ({ children, sx }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const rootStyles = useMemo(() => {
    return {
      overflow: "hidden",
      boxShadow:
        "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px",
      mb: 4,
      p: isMobile ? 2 : 4,
      display: "flex",
      flexDirection: "column",
      ...sx,
    };
  }, [sx, isMobile]);
  return <Card sx={rootStyles}>{children}</Card>;
};

const Header = ({
  title,
  subTitle,
  sx,
  titleSx,
  subTitleContent,
  endContent,
  expanded,
  expandedable,
  onExpandClick,
}) => {
  const rootStyles = useMemo(() => {
    return {
      mb: 2,

      ...sx,
    };
  }, [sx]);
  if (isNil(title)) return null;
  return (
    <Flx wrap gap={2} fw jb ac sx={rootStyles}>
      <Flx column gap={0.5}>
        <Htag sx={titleSx}>{title}</Htag>
        {subTitle && <Txt secondary>{subTitle}</Txt>}
        {subTitleContent}
      </Flx>
      <Flx ac>
        {!expandedable ? null : expanded ? (
          <Tooltip title="Collapse">
            <IconButton
              onClick={onExpandClick}
              sx={{ background: grey[200] }}
              size="small"
            >
              <CloseFullscreenOutlined className="thin" />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Expand">
            <IconButton onClick={onExpandClick} size="small">
              <OpenInFullOutlined className="thin" />
            </IconButton>
          </Tooltip>
        )}
        {endContent && <div>{endContent}</div>}
      </Flx>
    </Flx>
  );
};
export default PrimaryContentCard;
